import { Component } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { BaseEditFormComponent } from '../../../shared/base-edit-form/base-edit-form.component';

@Component({
  selector: 'tbody[lsz-soccer-hall-form]',
  templateUrl: './soccer-hall-form.component.html',
  styleUrls: ['./soccer-hall-form.component.css'],
})
export class SoccerHallFormComponent extends BaseEditFormComponent {

  public get surface(): AbstractControl {
    return this.form.get('surface');
  }

  public get length(): AbstractControl {
    return this.form.get('length');
  }

  public get width(): AbstractControl {
    return this.form.get('width');
  }

  public get isOnLzArea(): AbstractControl {
    return this.form.get('isOnLzArea');
  }

  public get isLzExclusive(): AbstractControl {
    return this.form.get('isLzExclusive');
  }

  public get hasBoards(): AbstractControl {
    return this.form.get('hasBoards');
  }

  constructor() {
    super();
  }
}
